import { css } from '@/styled-system/css';

export const modalBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
  minWidth: 0,
  overflowX: 'hidden',
});

export const stepBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  minWidth: 0,
  overflowX: 'hidden',
});

export const fieldStack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const statusCopy = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const filterTuning = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  paddingBlock: 'tighter',
});

export const rangeSliderInset = css({
  minWidth: 0,
  paddingInline: 'default',
});

export const actionRow = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  width: '100%',
  '& > button': {
    width: '100%',
  },
  lg: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    '& > button': {
      width: 'auto',
    },
  },
});

export const listingCarouselItem = css({
  // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
  width: '280px',
  sm: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
    width: '300px',
  },
  md: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- matches established ListingCarousel card rhythm
    width: '340px',
  },
});

export const listingCardShell = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  minWidth: 0,
});

export const statusText = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  margin: 'zero',
});

export const alertText = css({
  fontSize: 'body-sm',
  color: 'error',
  margin: 'zero',
});
